// extracted by mini-css-extract-plugin
module.exports = {"container":"PlayerDesktop_container_1spZw","warningText":"PlayerDesktop_warningText_2Sbs9"};